<template>
    <section class="maps">
        <div class="container">
            <h2 class="title _title">Выбери ближайший филиал</h2>

            <SmartShopsSlider :shops="shops" @onSelect="onSelectHandler" />
        </div>

        <div class="maps__map" :class="{ active: contactsMobileIsOpen }">

            <div class="container position-relative">
                <div id="map" class="maps__contact">
                    <!-- <SmartShopsContacts :shop="selectedShop" /> -->

                    <SmartShopsContactsMobile
                        :shop="selectedShop"
                        :isOpen="contactsMobileIsOpen"
                    />
                </div>
            </div>

            <div class="maps__map_overlay"></div>

            <div class="maps__map_back" @click="contactsMobileCloseHandler">
                <button class="_btn js-close-map">
                    <span class="_icon"
                        ><img
                            src="/assets/img/automatize/icons/arrow-top.svg"
                            alt=""
                    /></span>

                    <span>Назад</span>
                </button>
            </div>

            <SmartShopsMap :shop="selectedShop" />
        </div>
    </section>
</template>

<script>
import SmartShopsSlider from './SmartShopsSlider.vue';
// import SmartShopsContacts from './SmartShopsContacts.vue';
import SmartShopsContactsMobile from './SmartShopsContactsMobile.vue';
import SmartShopsMap from './SmartShopsMap.vue';

export default {
    components: {
        SmartShopsSlider,
        // SmartShopsContacts,
        SmartShopsContactsMobile,
        SmartShopsMap,
    },

    data() {
        return {
            shops: null,
            selectedShop: null,
            contactsMobileIsOpen: false,
        };
    },

    created() {
        this.getShops().then((shops) => {
            this.shops = shops;

            if (shops && shops.length) {
                this.selectedShop = shops[0];
            }
        });
    },

    computed: {
        isMobile() {
            const toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i,
            ];

            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });
        },
    },

    methods: {
        change(card) {
            this.map = card.map;
            this.cards = this.cards.map((e) => {
                e.active = false;
                if (card.id === e.id) {
                    e.active = true;
                }
                return e;
            });
        },

        onSelectHandler(shop) {
            if (this.isMobile || window.innerWidth <= 576) {
                this.contactsMobileIsOpen = !this.contactsMobileIsOpen;
            }

            this.selectedShop = shop;
        },

        contactsMobileCloseHandler() {
            this.contactsMobileIsOpen = false;
        },

        async getShops() {
            try {
                const response = await this.$http.get('/api/shops/contacts');

                const shops = response.body;

                return shops;
            } catch (e) {
                console.error('function getShops', e);

                return [];
            }
        },
    },
};
</script>
